import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { filter } from 'minimatch';
import { BehaviorSubject } from 'rxjs';
import { CurrencyDisplayService } from './currency-display.service';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  private filtersAppliedBehavior: BehaviorSubject<any> = new BehaviorSubject(null);
  public filtersApplied = this.filtersAppliedBehavior.asObservable();

  private ruleToggledAppliedBehavior: BehaviorSubject<any> = new BehaviorSubject(null);
  public ruleToggled = this.ruleToggledAppliedBehavior.asObservable();
  navFilterOptions: any = [];
  navFilter: any;

  constructor(
    private dataService: DataService,
    private currencyDisplayService: CurrencyDisplayService
  ) {
  }

  setFilterRule(rule, val, filters, itemList, resetFilters = true) {
    const filterConfigItem = filters.config.find(item => item.filterLabel === rule);
    if (filterConfigItem) {
      const filterRule = filterConfigItem.rules.find(item => item.label === val);
      if (filterRule) {
        if (resetFilters) {
          this.resetFilters(itemList, filters);
        }
        filterRule.applied = true;
        this.applyFilters(itemList, filters);
      }
    }
  }

  clearFilterRules(filterName, filtersData, itemList) {
    const filterConfigItem = filtersData.config.find(item => item.filterLabel === filterName);
    if (filterConfigItem) {
      filterConfigItem.rules.forEach(filterRule => {
        filterRule.applied = false;
        filterRule.ruleVal = undefined;
      });
      this.applyFilters(itemList, filtersData);
    }
  }

  clearFilterRule(rule, val, filters, itemList) {
    const filterConfigItem = filters.config.find(item => item.filterLabel === rule);
    if (filterConfigItem) {
      const filterRule = filterConfigItem.rules.find(item => item.label === val);
      if (filterRule) {
        filterRule.applied = false;
        filterRule.ruleVal = undefined;
        this.applyFilters(itemList, filters);
      }
    }
  }

  setFilterRuleValue(rule, val, filters, ruleValue) {
    const filterConfigItem = filters.config.find(item => item.filterLabel === rule);
    if (filterConfigItem) {
      const filterRule = filterConfigItem.rules.find(item => item.label === val);
      if (filterRule) {
        filterRule.applied = true;
        filterRule.ruleVal = ruleValue;
      }
    }
  }

  checkIfAnyRuleApplied(ruleLable, filters) {
    const filterConfigItem = filters.config.find(item => item.filterLabel === ruleLable);
    if (filterConfigItem) {
      return filterConfigItem.rules.find(item => item.applied);
    }
    return;
  }

  createFilters(itemList, filterConfig, idProp, initialFilters: any = {}) {
    itemList.forEach(item => {
      Object.keys(filterConfig).forEach((filterKey) => {
        filterConfig[filterKey].rules.forEach((rule, nRule) => {
          rule.id = `${rule.label}_${nRule}`;
          if (!rule.ids) {
            rule.ids = [];
          }
          if (rule.fn(item, (rule.val || ''))) {
            rule.ids.push(item[idProp]);
            if (filterConfig[filterKey].amountProp) {
              const amountProp = filterConfig[filterKey].amountProp;
              if (!rule[amountProp]) {
                rule[amountProp] = 0;
              }
              rule[amountProp] += item[amountProp];
              if (rule.otherData) {
                rule.otherData.amt = rule[amountProp];
              }
              rule.grpName = filterKey;
            }
          }
          //check if initialFilters value passed and set applied to true if, initially filters were applied
          if (initialFilters && initialFilters.appliedRules && initialFilters.appliedRules.length) {
            const initialRule = initialFilters.appliedRules.find(appRule => appRule.id === rule.id);
            if (initialRule) {
              rule.applied = initialRule.applied;
            }
          } else {
            rule.applied = false;
          }
          rule.orgIds = [...rule.ids];
        });
      });
      item.isVisible = true;

    });
    const retFilters = {
      config: Object.keys(filterConfig).map(filterKey => {
        const filteItem = filterConfig[filterKey];
        return {
          filterLabel: filteItem.label,
          rules: filteItem.rules || [],
          amountProp: filteItem.amountProp,
          isVisible: ((filteItem.rules || []).filter(rule => (rule.ids || []).length > 0).length > 0),
          resetFilters: filteItem.resetFilters,
          isValueFilter: filteItem.isValueFilter,
          isTemplate: filteItem.isTemplate,
          isCreateDate: filteItem.isCreateDate,
          hiddenFilter: filteItem.hiddenFilter
        };
      }),
      idProp: idProp,
      configsVisible: Object.keys(filterConfig).length
    };
    this.applyFilters(itemList, retFilters);
    return retFilters;
  }

  applyFilters(itemList, filterConfig, rule = undefined) {
    const appliedRules = [];
    const appliedGrps = {};
    let appliedIds = [];
    const itemObj = {};
    itemList.forEach(item => {
      itemObj[item[filterConfig.idProp]] = item;
    });

    // reset rule ids
    filterConfig.config.forEach(filter => {
      filter.rules.forEach(rule => {
        if (filter.isValueFilter && rule.ruleVal) {
          rule.ids = itemList.filter(item => {
            return rule.fn(item, rule.ruleVal);
          }).map(item => item.docId);
          rule.applied = true;
        } else if (filter.isTemplate && filter.isCreateDate) {
          if (rule.fromCreateDate && rule.toCreateDate) {
            rule.ids = itemList.filter(item => {
              return rule.fn(item, rule);
            }).map(item => item.docId);
            rule.applied = true;
          } else {
            rule.ids = rule.orgIds ? [...rule.orgIds] : [];
          }
        } else {
          rule.ids = rule.orgIds ? [...rule.orgIds] : [];
        }
      });
    });

    filterConfig.config.forEach(filter => {
      filter.appliedRules = filter.rules.filter(rule => rule.applied);
      appliedRules.push(...filter.appliedRules);
    });

    // get union of all the groups applied
    appliedRules.forEach((rule) => {
      if (!appliedGrps[rule.grpName]) {
        appliedGrps[rule.grpName] = [];
      }
      appliedGrps[rule.grpName].push(...rule.ids);
    });
    Object.keys(appliedGrps).forEach(appliedgrpKey => {
      if (!appliedIds.length) {
        appliedIds = [...appliedGrps[appliedgrpKey]];
      } else {
        appliedIds = appliedIds.filter(x => appliedGrps[appliedgrpKey].includes(x));
      }
    });

    let itemsVisible = 0;
    if (!appliedRules.length) {
      itemList.forEach(item => {
        item.isVisible = true;
      });
      itemsVisible = itemList.length;
    } else {
      filterConfig.config.forEach(filter => {
        filter.rules.forEach(rule => {
          Object.keys(appliedGrps).forEach(grpKey => {
            if (grpKey !== rule.grpName) {
               
              //rule.ids = rule.ids.filter(x => appliedIds.includes(x));
              rule.ids = rule.ids.filter(x => appliedGrps[grpKey].includes(x));
            }
          });
        });
      });


      itemList.forEach(item => {
        if (appliedIds.indexOf(item[filterConfig.idProp]) !== -1) {
          item.isVisible = true;
          itemsVisible += 1;
        } else {
          item.isVisible = false;
        }
      });
    }
    filterConfig.itemsVisible = itemsVisible;

    filterConfig.config.forEach(filter => {
      if (!filter.isTemplate || !filter.appliedRules.length) {
        filter.isVisible = filter.rules.filter(rule => (rule.ids || []).length > 0).length > 0;
      }
    });

    this.setFilterAmounts(itemObj, filterConfig);

    filterConfig.appliedRules = appliedRules;
    filterConfig.configsVisible = filterConfig.config.filter(config => config.isVisible).length;
    if (rule) {
      this.ruleToggledAppliedBehavior.next(rule);
    }
    this.filtersAppliedBehavior.next(new Date().getTime());
  }

  resetFilters(itemList, filterConfig) {
    filterConfig.config.forEach((config) => {
      config.rules.forEach(rule => {
        rule.applied = false;
        rule.ruleVal = undefined;
      });
      if (config.isTemplate && config.isCreateDate) {
        config.rules[0].fromCreateDate = undefined;
        config.rules[0].toCreateDate = undefined;
      }
    });
    this.applyFilters(itemList, filterConfig);
  }

  disableFilters(filterConfig, excludeConfigs = []) {
    filterConfig.config.forEach((config) => {
      if (excludeConfigs.indexOf(config.filterLabel.toLowerCase()) === -1) {
        config.rules.forEach(rule => {
          rule.disabled = true;
        });
      }
    });
  }

  enableFilters(filterConfig) {
    filterConfig.config.forEach((config) => {
      config.rules.forEach(rule => {
        rule.disabled = false;
      });
    });
  }

  setFilterAmounts(itemObj, filterConfig) {
    // calculate amounts again
    filterConfig.config.forEach((config) => {
      config.rules.forEach(rule => {
        rule.amtDetails = { dispalyStr: '', amts: [] };
        const ruleAmtObj = {};
        if (rule.ids.length) {
          rule.ids.forEach(itemId => {
            const amtObj = ((itemObj[itemId][config.amountProp] || []).amts || [])[0];
            if (amtObj) {
              if (!ruleAmtObj[amtObj.curr]) {
                ruleAmtObj[amtObj.curr] = { amt: amtObj.amt, curr: amtObj.curr };
              } else {
                ruleAmtObj[amtObj.curr].amt += amtObj.amt;
              }
            }
          });
          Object.keys(ruleAmtObj).forEach(key => {
            ruleAmtObj[key].formattedAmt = this.currencyDisplayService.getFormattedCurrencyStr(ruleAmtObj[key]);
            rule.amtDetails.amts.push(ruleAmtObj[key]);
          });
          rule.amtDetails.dispalyStr = rule.amtDetails.amts.map(amt => amt.formattedAmt).join(', ');
        }
      });
    });
  }
  setNavFilters(navFilter){
    this.navFilter = navFilter;
  }
  getNavFilters(){
    return this.navFilter
  }
  clearNavFilters(){
    this.navFilter = undefined;
  }
}